import { z } from 'zod';

import { ComponentValidator, ComponentPayloadValidator } from '../Component';

import { AbstractPort, Port } from '../fields/AbstractPort';

import { ComponentDefinition } from '../../types/ComponentDefinition';

const port = AbstractPort.extend({
    AC: Port.AC.default({}),
    DC: Port.DC.default({}),
    isolated: Port.isolated.validator.default(false),
}).default({
    powerFlowDirection: 'bidirectional',
});

const CustomBase = z.object({
    type: z.literal('custom').default('custom'),
    electrical: z
        .object({
            ports: z.array(port).min(1).default([undefined]),
            actsAsConverter: z.boolean().default(true),
        })
        .default({}),
});

export const CustomValidator = ComponentValidator.merge(CustomBase);
export const CustomPayloadValidator = ComponentPayloadValidator.merge(CustomBase);

export const CustomDefinition: ComponentDefinition = {
    type: 'custom',
    name: 'Custom',
    plural: 'Custom',
    indicator: 'X',
    allowCustomIcon: true,
    hasDynamicNumberOfPorts: true,
    interoperabilityDataModel: false,
    ports: {
        min: 1,
        max: Infinity,
        powerFlowDirections: ['input', 'output', 'bidirectional'],
    },
    liveData: {
        enabled: true,
        showGraphs: true,
    },
    validators: {
        component: CustomValidator,
        payload: CustomPayloadValidator,
    },
};

export type Custom = z.infer<typeof CustomValidator>;
export type CustomPayload = z.infer<typeof CustomPayloadValidator>;
